export const screeningNavigationStatus = {
  DROPPED: 'DROPPED',
  COMPLETED: 'COMPLETED'
}
